import { User } from "./User";
import { UserGroup } from "./UserGroup";

export class PermissibleUser {

	public user!: User;
	public isPermissionExact!: boolean;
	public userGroup?: UserGroup;
}
